import { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Tab, TabList } from "@fluentui/react-tabs";
import CustomBreadCrumb from "../../components/CustomBreadCrumb";
import { TOAST_TYPE, USERTYPES, AuthRoutes } from "../../constants/Constants";
import userContext from "../../context/users/UserContext";
import { t } from "i18next";
import themeContext from "../../context/theme/ThemeContext";
import { DefaultButton, Icon, PrimaryButton } from "@fluentui/react";
import Select from "react-select";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "../ReportTemplates/ReportTemplate.css";
import "../StudyList/StudyList.css";
import "../../components/ListView/ListViewStyles.css";
import "../../components/LisViewTable/ListViewTableStyles.css";
import SortPopupFilterSectionV4 from "../../components/ListViewV4/SortPopupFilterSectionV4";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import {
  deleteStyleApi,
  getLLMAgentList,
  getStylesList,
  getPersonalTemplates,
  createPersonalTemplate,
  updatePersonalTemplate,
  deletePersonalTemplate,
  addOrUpdateStyle,
} from "../../service/MasterService";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import ListViewTableV3 from "../../components/ListViewV3/ListViewTableV3";
import { constantStyleForSelect } from "../../components/CustomSelect";
import { getEnv } from "../../helpers/EnvHelper";

const MyStyles = () => {
  // Added for personal template: keep one cache instance while editing content.
  const queryClient = useMemo(() => new QueryClient(), []);
  const { getThemeColor, getAlterColor, themeName } = useContext(themeContext);
  const { roles, loadByUsername, authenticated } = useContext(userContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);

  const isLightMode = themeName === "Light" || themeName === "light";
  const alterBg = getAlterColor ? getAlterColor("background-color") : null;
  const themeBg = getThemeColor("background");

  const mainBackgroundColor = isLightMode ? "#ffffff" : (alterBg || themeBg || "#000000");

  const [breadCrumbItems, setBreadCrumbItems] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [dataQueryState, setDataQueryState] = useState(null);
  const [selectedRow, setSelectedRow] = useState(0);
  const [listViewLoading, setListViewLoading] = useState(false);
  const listViewRef = useRef(null);
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [deletedId, setDeletedId] = useState();
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [styleToDelete, setStyleToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("styles");
  const [isTemplateEditing, setIsTemplateEditing] = useState(false);
  const [templateToEdit, setTemplateToEdit] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [templateContent, setTemplateContent] = useState("");
  const templateContentRef = useRef("");
  const [isAddingTemplate, setIsAddingTemplate] = useState(false);
  const [agentOptions, setAgentOptions] = useState([]);
  const [templateRefreshKey, setTemplateRefreshKey] = useState(0);
  const [templateToDelete, setTemplateToDelete] = useState(null);
  const [showTemplateDeleteConfirmModal, setShowTemplateDeleteConfirmModal] =
    useState(false);
  const [templatePageIndex, setTemplatePageIndex] = useState(0);
  const [templatePageSize, setTemplatePageSize] = useState(10);
  const [templateFilterObj, setTemplateFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
const [isStyleEditing, setIsStyleEditing] = useState(false);
const [isAddingStyle, setIsAddingStyle] = useState(false);
const [styleToEdit, setStyleToEdit] = useState(null);
const [selectedStyleAgent, setSelectedStyleAgent] = useState(null);
const [stylePromptContent, setStylePromptContent] = useState("");
//const [styleAgentOptions, setStyleAgentOptions] = useState([]);
//const [allStylesData, setAllStylesData] = useState([]);
const [styleRefreshKey, setStyleRefreshKey] = useState(0);
  const [templateDataQueryState, setTemplateDataQueryState] = useState(null);
  const [templateSelectedRow, setTemplateSelectedRow] = useState(0);
  const [templateListViewLoading, setTemplateListViewLoading] = useState(false);
  const templateListViewRef = useRef(null);

  const navigate = useNavigate();

  const handleAddNewStyle = () => {
    //navigate(AuthRoutes.ADD_STYLE);
  setIsAddingStyle(true);
  setIsStyleEditing(true);
  setStyleToEdit(null);
  setSelectedStyleAgent(null);
  setStylePromptContent("");
    setSelectedStyle({
    id: "new",
    agentId: null,
    title: "",
    styles: "",
    isNew: true,
  });
  setSelectedRow(0);
  setStyleRefreshKey((value) => value + 1);
  };

  useEffect(() => {
    setBreadCrumbItems([
      {
        text: t("navbar.agentic-style"),
        key: "my_styles",
      },
    ]);
  }, [roles]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, [authenticated]);

  useEffect(() => {
    if (dataQueryState && dataQueryState.data && dataQueryState.data.rows && dataQueryState.data.rows.length > 0) {
      setSelectedStyle(dataQueryState.data.rows[0]);
    }
  }, [dataQueryState]);

  // Added for personal template: load dropdown options without changing style fetching.
  useEffect(() => {
    const fetchTemplateAgents = async () => {
      try {
        const response = await getLLMAgentList();
        const options = (response?.data?.data || []).map((agent) => ({
          value: agent.id,
          label: agent.title,
        }));
        setAgentOptions(options);
      } catch (error) {
        showToastv2(TOAST_TYPE.ERROR, t("myStyles.failedToFetchAgents"));
      }
    };

    // if (authenticated && activeTab === "templates") {
    if (authenticated  && agentOptions.length === 0) {
      fetchTemplateAgents();
    }
  }, [authenticated, activeTab, agentOptions.length]);
  // }, [authenticated, activeTab]);

  // Added for personal template
  useEffect(() => {
    const rows = templateDataQueryState?.data?.rows || [];

    if (rows.length === 0) {
      if (!isTemplateEditing) {
        setSelectedTemplate(null);
      }
      return;
    }

    if (
      !isTemplateEditing &&
      !rows.some((row) => row.templateId === selectedTemplate?.templateId)
    ) {
      setSelectedTemplate(rows[0]);
      setTemplateSelectedRow(0);
    }
  }, [templateDataQueryState, isTemplateEditing, selectedTemplate?.templateId]);

  const MyStylesTabSection = () => {
    return (
      <TabList
        style={{ marginLeft: "10px" }}
        className="tab-list-container-cmp tabList"
        //selectedValue="tab_1"
        selectedValue={activeTab}
        onTabSelect={(_, data) => {
  setActiveTab(data.value);

  if (data.value === "styles") {
    setPageIndex(0);
    setFilterObj({
      filterInput: null,
      filterUpdate: filterObj.filterUpdate + 1,
    });
  } else {
    setTemplatePageIndex(0);
    setTemplateFilterObj({
      filterInput: null,
      filterUpdate: templateFilterObj.filterUpdate + 1,
    });
  }
}}
      >
        <Tab
          // key="tab_1"
          // className="top-tab-cmp"
          // id="tab_1"
          // value="tab_1"
            key="styles"
           className="top-tab-cmp"
          id="styles"
          value="styles"
          style={{
            borderTop: activeTab === "styles" ? "1px solid #7E7E7E" : "none",
            borderLeft: activeTab === "styles" ? "1px solid #7E7E7E" : "none",
            borderRight: activeTab === "styles" ? "1px solid #7E7E7E" : "none",
            borderBottom: "none",
            borderRadius: activeTab === "styles" ? "10px 10px 0px 0px" : "0px",
          }}
        >
          <div
            className="tabContent"
            style={{
              padding: "0px 15px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h4
              className={`textContent-study-list ${
                activeTab === "styles" ? "highlight-tab" : ""
              }`}
              style={{ marginLeft: 0 }}
            >
              {t("myStyles.title")}
            </h4>
            {activeTab === "styles" && (
              <div className="hide-border-bottom-border-tabs"></div>
            )}
          </div>
        </Tab>
        {/* added for personal template */}
        <Tab
          key="templates"
          value="templates"
          className="top-tab-cmp"
          style={{
            marginLeft: "6px",
            borderTop: activeTab === "templates" ? "1px solid #7E7E7E" : "none",
            borderLeft: activeTab === "templates" ? "1px solid #7E7E7E" : "none",
            borderRight: activeTab === "templates" ? "1px solid #7E7E7E" : "none",
            borderBottom: "none",
            borderRadius: activeTab === "templates" ? "10px 10px 0px 0px" : "0px",
          }}
        >
          <div
            className="tabContent"
            style={{
              padding: "0px 15px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h4
              className={`textContent-study-list ${
                activeTab === "templates" ? "highlight-tab" : ""
              }`}
              style={{ marginLeft: 0 }}
            >
              {t("myStyles.myTemplates")}
            </h4>
            {activeTab === "templates" && (
              <div className="hide-border-bottom-border-tabs"></div>
            )}
          </div>
        </Tab>
      </TabList>
    );
  };

  const handleApplyClick = (filterValue) => {
    console.log("Search applied with value:", filterValue);

   
    if (activeTab === "styles") {
      setFilterObj({
        filterInput: filterValue,
        filterUpdate: filterObj.filterUpdate + 1,
      });
      return;
    }
    setTemplatePageIndex(0);
    setTemplateFilterObj({
      filterInput: filterValue,
      filterUpdate: templateFilterObj.filterUpdate + 1,
    });
  };

  const buttonsTopBar = [
    {
      key: "1",
      button: (

        <div className="add-button-list-view">
        <PrimaryButton
          text={
            activeTab === "styles"
              ? t("myStyles.addNewStyle")
              : t("myStyles.addNewTemplate")
          }
          className="common-default-active-button list-view-top-buttons-styles"
          onClick={() => {
            if (activeTab === "styles") {
              handleAddNewStyle();
            } else {
             
              setIsAddingTemplate(true);
              setTemplateToEdit(null);
              setSelectedAgent(null);
              setTemplateContent("");
             
              templateContentRef.current = "";
              setSelectedTemplate({
                templateId: "new",
                agentId: null,
                agentName: "",
                templateContent: "",
                isNew: true,
              });
              setTemplateSelectedRow(0);
              setIsTemplateEditing(true);
              setTemplateRefreshKey((value) => value + 1);
            }
          }}
        />
      </div>
      ),
    },
  ];
  const fetchStylesData = async (options) => {
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const [stylesResponse, agentsResponse] = await Promise.all([
        getStylesList(),
        getLLMAgentList()
      ]);

      if (stylesResponse.status !== 200 || stylesResponse.data.result !== "SUCCESS") {
        throw new Error("Failed to fetch styles");
      }

      let rawStyles = stylesResponse.data.data.styles || [];
      const agents = agentsResponse?.data?.data || [];

      const agentMap = agents.reduce((acc, agent) => {
        acc[agent.id] = agent.title;
        return acc;
      }, {});

      let results = rawStyles.map(style => ({
        ...style,
        title: agentMap[style.agentId] || "Unknown Agent"
      }));

      const processedData = {
        rows: results,
        pageCount: Math.ceil(results.length / options.pageSize),
      };

      console.log("Processed data being returned:", processedData);

      if (options.filterObj.filterInput) {
        const searchTerm = options.filterObj.filterInput.toLowerCase();
        results = results.filter(item =>
          (item.title && item.title.toLowerCase().includes(searchTerm)) ||
          (item.styles && item.styles.toLowerCase().includes(searchTerm))
        );
      }

      if (options.sortObj.sortFieldValue && options.sortObj.sortFieldValue.length > 0) {
        const sortField = options.sortObj.sortFieldValue;
        const sortDir = options.sortObj.sortDir;
        results.sort((a, b) => {
          let aValue = a[sortField] || '';
          let bValue = b[sortField] || '';

          if (typeof aValue === 'string') {
            aValue = aValue.toLowerCase();
            bValue = bValue.toLowerCase();
          }

          if (sortDir) {
            return aValue > bValue ? 1 : -1;
          } else {
            return aValue < bValue ? 1 : -1;
          }
        });
      }
      if (isAddingStyle) {
        results = [
          {
            id: "new",
            agentId: null,
            title: "",
            styles: "",
            isNew: true,
          },
          ...results,
        ];
      }
      const startIndex = options.page * options.pageSize;
      const endIndex = startIndex + options.pageSize;
      const paginatedResults = results.slice(startIndex, endIndex);

      processedData.rows = paginatedResults;

      setLoaderRunning(false);
      ref.current.complete();

      return processedData;

    } catch (error) {
      console.error("Error in fetchStylesData:", error);
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2("error", t("myStyles.errorFetching"));
      return {
        rows: [],
        pageCount: 0,
      };
    }
  };
  // Added for personal template
const fetchTemplatesData = async (options) => {
    setLoaderRunning(true);
  ref.current?.continuousStart();
  try {
    const response = await getPersonalTemplates();

    if (
      response.status !== 200 ||
      response.data.result !== "SUCCESS"
    ) {
      return {
        rows: [],
        pageCount: 0,
      };
    }

    let results = response.data.data || [];

if (options.filterObj.filterInput) {
  const searchTerm = options.filterObj.filterInput.toLowerCase();

  results = results.filter(
    (item) =>
      (item.agentName && item.agentName.toLowerCase().includes(searchTerm)) ||
      (item.templateContent &&
        item.templateContent.toLowerCase().includes(searchTerm)),
  );
}

    if (isAddingTemplate) {
      results = [
        {
          templateId: "new",
          agentId: null,
          agentName: "",
          templateContent: "",
          isNew: true,
        },
        ...results,
      ];
    }

    const start = options.page * options.pageSize;
    const end = start + options.pageSize;

    return {
      rows: results.slice(start, end),
      pageCount: Math.ceil(results.length / options.pageSize),
    };
  } catch (e) {
    return {
      rows: [],
      pageCount: 0,
    };
  } finally{
       
    setLoaderRunning(false);
    ref.current?.complete();
  }
};

  // Added for personal template: independent pagination from My Styles.
  const setTemplatePagination = (updater) => {
    const newPagination = updater({
      pageIndex: templatePageIndex,
      pageSize: templatePageSize,
    });
    setTemplatePageIndex(newPagination.pageIndex);
    setTemplatePageSize(newPagination.pageSize);
  };

  // Added for personal template: shared reset for Add/Edit Cancel and successful Save.
  const closeTemplateEditor = () => {
    setIsTemplateEditing(false);
    setIsAddingTemplate(false);
    setTemplateToEdit(null);
    setSelectedAgent(null);
    setTemplateContent("");
    
    templateContentRef.current = "";
  };

  const saveTemplate = async () => {
    
    const currentTemplateContent = templateContentRef.current;

    if (!selectedAgent) {
      showToastv2(TOAST_TYPE.ERROR, t("myStyles.selectAgentValidation"));
      return;
    }

    if (!currentTemplateContent.trim()) {
      showToastv2(TOAST_TYPE.ERROR, t("myStyles.templateContentValidation"));
      return;
    }

    const payload = {
      agentId: selectedAgent.value,
      templateContent: currentTemplateContent,
      ...(templateToEdit && { templateId: templateToEdit.templateId }),
    };

    setLoaderRunning(true);
    ref.current?.continuousStart();

    try {
      const response = templateToEdit
        ? await updatePersonalTemplate(payload)
        : await createPersonalTemplate(payload);

      if (response?.data?.result !== "SUCCESS") {
        showToastv2(
          TOAST_TYPE.ERROR,
          response?.data?.message || t("myStyles.failedToSaveTemplate")
        );
        return;
      }

      showToastv2(
        TOAST_TYPE.SUCCESS,
        templateToEdit ? t("myStyles.templateUpdated") : t("myStyles.templateUpdated")
      );
      // Added for personal template: update edited row locally without refetching /personal.
if (templateToEdit && templateDataQueryState?.data?.rows) {
  const updatedRows = templateDataQueryState.data.rows.map((row) =>
    row.agentId === selectedAgent.value
      ? {
          ...row,
          agentId: selectedAgent.value,
          agentName: selectedAgent.label,
          templateContent: currentTemplateContent,
        }
      : row
  );

  setTemplateDataQueryState({
    ...templateDataQueryState,
    data: {
      ...templateDataQueryState.data,
      rows: updatedRows,
    },
  });

  setSelectedTemplate({
    ...templateToEdit,
    agentId: selectedAgent.value,
    agentName: selectedAgent.label,
    templateContent: currentTemplateContent,
  });

  closeTemplateEditor();
  return;
}
      setSelectedTemplate({
        ...templateToEdit,
        agentId: selectedAgent.value,
        agentName: selectedAgent.label,
        templateContent: currentTemplateContent,
      });
      closeTemplateEditor();
      setTemplateRefreshKey((value) => value + 1);
    } catch (error) {
      showToastv2(TOAST_TYPE.ERROR, t("myStyles.errorSavingTemplate"));
    } finally {
      setLoaderRunning(false);
      ref.current?.complete();
    }
  };

  // Added for personal template
  const openTemplateDeleteConfirm = (template) => {
    setTemplateToDelete(template);
    setShowTemplateDeleteConfirmModal(true);
  };

  // Added for personal template: backend delete endpoint expects agentId.
  const deleteTemplate = async () => {
    if (!templateToDelete) return;

    setLoaderRunning(true);
    ref.current?.continuousStart();

    try {
      const response = await deletePersonalTemplate(templateToDelete.agentId);

      if (response?.data?.result !== "SUCCESS") {
        showToastv2(
          TOAST_TYPE.ERROR,
          response?.data?.message || t("myStyles.failedToDeleteTemplate")
        );
        return;
      }

      showToastv2(TOAST_TYPE.SUCCESS, t("myStyles.templateDeleted"));
      if (selectedTemplate?.agentId === templateToDelete.agentId) {
        setSelectedTemplate(null);
      }
      closeTemplateEditor();
      setShowTemplateDeleteConfirmModal(false);
      setTemplateToDelete(null);
      setTemplateRefreshKey((value) => value + 1);
    } catch (error) {
      showToastv2(TOAST_TYPE.ERROR, t("myStyles.errorDeletingTemplate"));
    } finally {
      setLoaderRunning(false);
      ref.current?.complete();
    }
  };

  // Added for personal template: memoize Froala config so the editor does not reinitialize while typing.
  const personalTemplateEditorConfig = useMemo(() => ({
    placeholderText: "Add your template here...",
    key: getEnv("REACT_APP_FROALA_API_KEY"),
    charCounterCount: false,
    attribution: false,
      imagePaste: false,
  imageUpload: false,
  fileUpload: false,

    width: "100%",
    fontSizeDefault: "12",
    fontSizeUnit: "px",
    pluginsEnabled: [
      "fullscreen",
      "codeBeautifier",
      "colors",
      "fontFamily",
      "fontSize",
      "paragraphFormat",
      "paragraphStyle",
      "align",
      "lists",
      "table",
      "wordPaste",
    ],
    toolbarButtons: {
      moreText: {
        buttons: [
          "undo",
          "redo",
          "|",
          "paragraphFormat",
          "|",
          "fontFamily",
          "|",
          "fontSize",
          "|",
          "bold",
          "italic",
          "underline",
          "strikeThrough",
          "clearFormatting",
          "|",
          "textColor",
          "backgroundColor",
          "|",
          "alignLeft",
          "alignCenter",
          "alignRight",
          "alignJustify",
          "formatOL",
          "formatUL",
          "outdent",
          "indent",
          "|",
          "insertTable",
        ],
        align: "left",
        buttonsVisible: 10,
      },
    },
    events: {
  "paste.before": function (event) {
    const clipboardData =
      event?.clipboardData || event?.originalEvent?.clipboardData;

    if (!clipboardData) return true;

    const items = clipboardData.items || [];

    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (
        item.kind === "file" ||
        item.type?.startsWith("image/") ||
        item.type?.startsWith("video/") ||
        item.type?.startsWith("audio/") ||
        item.type === "application/pdf"
      ) {
        return false;
      }
    }

    return true;
  },

  "image.beforeUpload": function () {
    return false;
  },

  "file.beforeUpload": function () {
    return false;
  },
},
  }), []);

  const SelectedTemplateComponent = () => {
    if (isTemplateEditing) {
      return (
        <div
          style={{
          
            height: "100%",
            padding: "20px",
            boxSizing: "border-box",
            backgroundColor: mainBackgroundColor,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Added for personal template: Agent dropdown is rendered in the left row, like Agentic Report Template. */}

          <div
            className="personal-template-editor"
            style={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
              backgroundColor: "#ffffff",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FroalaEditor
              tag="textarea"
              model={templateContent}
      
              onModelChange={(value) => {
                templateContentRef.current = value;
              }}
              config={personalTemplateEditorConfig}
            />
          </div>

          {/* Added for personal template: keep Save and Cancel permanently visible. */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              paddingTop: "12px",
              justifyContent: "flex-start",
              flexShrink: 0,
              backgroundColor: mainBackgroundColor,
            }}
          >
            <DefaultButton
  text="Cancel"
  onClick={() => {
   
    closeTemplateEditor();

    
    setTemplateRefreshKey((value) => value + 1);
  }}
/>
            <PrimaryButton text="Save" onClick={saveTemplate} />
          </div>
        </div>
      );
    }

    if (!selectedTemplate) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: mainBackgroundColor,
          }}
        >
          {t("myStyles.selectAgentPreview")}
        </div>
      );
    }

    return (
      <div
        style={{
          // Added for personal template: use the same spacing as the Add/Edit panel.
          height: "100%",
          width: "100%",
          padding: "20px",
          boxSizing: "border-box",
          backgroundColor: mainBackgroundColor,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            // Added for personal template: fill the detail panel without extra margins or overflow.
            width: "100%",
            height: "100%",
            backgroundColor: "#fff",
            borderRadius: "10px",
            padding: "12px",
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{ color: "#000000", wordBreak: "break-word" }}
            dangerouslySetInnerHTML={{
              __html: selectedTemplate.templateContent,
            }}
          />
        </div>
      </div>
    );
  };

  const setPagination = (updater) => {
    const newPagination = updater({
      pageIndex,
      pageSize,
    });
    setPageIndex(newPagination.pageIndex);
    setPageSize(newPagination.pageSize);
  };

  const handleUserClick = (cell) => {
    console.log("Row clicked:", cell.row.original);
    setSelectedRow(cell.row.index);
    setSelectedStyle(cell.row.original);
  };

  const handleEdit = (style) => {
    //navigate(`/styles/edit/${styleId}`);
  setSelectedStyle(style);
  setStyleToEdit(style);
  setSelectedStyleAgent({
    value: style.agentId,
    label: style.title,
  });
  setStylePromptContent(style.styles || "");
  setIsAddingStyle(false);
  setIsStyleEditing(true);
  };
const closeStyleEditor = () => {
  const fallbackStyle =
    styleToEdit || dataQueryState?.data?.rows?.find((style) => !style.isNew) || null;

  setIsAddingStyle(false);
  setIsStyleEditing(false);
  setStyleToEdit(null);
  setSelectedStyleAgent(null);
  setStylePromptContent("");
  setSelectedStyle(fallbackStyle);
  setSelectedRow(0);
  setStyleRefreshKey((value) => value + 1);
};

const saveStyle = async () => {
  const trimmedPrompt = stylePromptContent?.trim();

  if (!selectedStyleAgent) {
    showToastv2(TOAST_TYPE.ERROR, t("addStyle.selectTemplate"));
    return;
  }

  if (!trimmedPrompt) {
    showToastv2(TOAST_TYPE.ERROR, t("addStyle.fillPrompt"));
    return;
  }

 if (
  isAddingStyle &&
  dataQueryState?.data?.rows?.some(
    (style) =>
      style.agentId === selectedStyleAgent.value ||
      (!style.agentId && style.title === selectedStyleAgent.label)
  )
) {
    showToastv2(
      TOAST_TYPE.ERROR,
      `A prompt for "${selectedStyleAgent.label}" already exists. Please edit it instead.`
    );
    return;
  }

  const payload = {
    ...(styleToEdit?.id && { id: Number(styleToEdit.id) }),
    agentId: selectedStyleAgent.value,
    styles: trimmedPrompt,
  };

  setLoaderRunning(true);
  ref.current?.continuousStart();

  try {
    const response = await addOrUpdateStyle(payload);

    if (
      response?.data?.result === "SUCCESS" ||
      [200, 201].includes(response?.status)
    ) {
      showToastv2(
        TOAST_TYPE.SUCCESS,
       // response.data?.message ??
          (styleToEdit ? t("addStyle.updatedSuccess") : t("addStyle.createdSuccess"))
      );

      closeStyleEditor();
      setStyleRefreshKey((value) => value + 1);

      if (listViewRef.current) {
        listViewRef.current.refresh();
      }
    } else {
      showToastv2(
        TOAST_TYPE.ERROR,
        response?.data?.message ?? `Failed to ${styleToEdit ? "update" : "add"} prompt`
      );
    }
  } catch (error) {
    showToastv2(
      TOAST_TYPE.ERROR,
      `Error ${styleToEdit ? "updating" : "adding"} prompt`
    );
  } finally {
    setLoaderRunning(false);
    ref.current?.complete();
  }
};
  const deleteConfirmModal = (style) => {
    setStyleToDelete(style);
    setShowDeleteConfirmModal(true);
  };

  const deleteStyle = async () => {
    if (!styleToDelete) return;
    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await deleteStyleApi({ id: styleToDelete.id });

      if (response.status === 200 && response.data.result === "SUCCESS") {
        showToastv2(TOAST_TYPE.SUCCESS, t("myStyles.styleDeleted"));
        setShowDeleteConfirmModal(false);
        setStyleToDelete(null);

        if (dataQueryState?.data?.rows) {
          const updatedRows = dataQueryState.data.rows.filter(
            (row) => row.id !== styleToDelete.id
          );
          setDataQueryState({
            ...dataQueryState,
            data: {
              ...dataQueryState.data,
              rows: updatedRows
            }
          });

          if (selectedStyle?.id === styleToDelete.id) {
            setSelectedStyle(updatedRows[0] || null);
            setSelectedRow(0);
          }
        }

        queryClient.invalidateQueries("styles-list");
        if (listViewRef.current) {
          listViewRef.current.refresh();
        }
      } else {
        showToastv2(
          TOAST_TYPE.ERROR,
          response.data.message || "Failed to delete style"
        );
      }
    } catch (error) {
      showToastv2(TOAST_TYPE.ERROR, "Error deleting style");
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const columns = [
    {
       
      accessorKey: "title",
      header: t("myStyles.reportTemplate"),
      cell: (info) => {
        const style = info.row.original;
        const isEditingThisStyle =
            isStyleEditing && (style.isNew || style.id === styleToEdit?.id);
        const value = info.getValue();
        const modality = info.row.original.modality || "DX";
        return (
          <div style={{
            padding: "8px 0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            boxSizing: "border-box"
          }}>
            {isEditingThisStyle ? (
  <div style={{ width: "calc(100% - 25px)" }}>
    <Select
      options={agentOptions}
      value={selectedStyleAgent}
      onChange={setSelectedStyleAgent}
      isDisabled={!!styleToEdit}
      styles={{
        ...constantStyleForSelect(getThemeColor),
        singleValue: (base) => ({
          ...base,
          color: getThemeColor("primary-color"),
          opacity: 1,
        }),
        input: (base) => ({
          ...base,
          color: getThemeColor("primary-color"),
        }),
      }}
      placeholder="Select Agent..."
    />
  </div>
) : (
            <div style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              fontWeight: "500",
              marginBottom: "4px",
              width: "100%"
            }}>
              {value}
            </div>
          )}
           {!isEditingThisStyle && (
            <div style={{ display: "flex", gap: "10px", marginRight: "15px", flexShrink: 0 }}>
              <Icon
                iconName="Edit"
                style={{
                  fontSize: 17,
                   cursor: isStyleEditing ? "not-allowed" : "pointer",
                   opacity: isStyleEditing ? 0.5 : 1,
                }}
               // onClick={() => handleEdit(info.row.original.id)}
               onClick={(event) => {
  event.stopPropagation();
   if (isStyleEditing) return;
  setSelectedRow(info.row.index);
  setSelectedStyle(info.row.original);
  handleEdit(info.row.original);
}}
              />
              <Icon
                iconName="Delete"
                style={{
                  fontSize: 17,
                    cursor: isStyleEditing ? "not-allowed" : "pointer",
                    opacity: isStyleEditing ? 0.5 : 1,
                }}
              //  onClick={() => deleteConfirmModal(info.row.original)}
              onClick={(event) => {
  event.stopPropagation();
  if (isStyleEditing) return;
  deleteConfirmModal(info.row.original);
}}
              />
            </div> )}
          </div>
        );
      },
      show: true,
      headerClass: "list-view-header-cell",
      className: "list-view-cell",
      style: { width: "100%" },
      headerStyle: { width: "100%" }
    }
  ];
  // Added for personal template: same left-list visual pattern as My Styles.
  const templateColumns = [
    {
      accessorKey: "agentName",
      header: "Agent",
      cell: (info) => {
        const template = info.row.original;
        const isEditingThisTemplate =
          isTemplateEditing &&
          (template.isNew ||
            template.templateId === templateToEdit?.templateId);

        return (
          <div
            style={{
              padding: "8px 0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            {/* Added for personal template: Agent dropdown is now in the left row, not above Froala. */}
            {isEditingThisTemplate ? (
              <div style={{ width: "calc(100% - 25px)" }}>
                <Select
                  options={agentOptions}
                  value={selectedAgent}
                  onChange={setSelectedAgent}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{
                    ...constantStyleForSelect(getThemeColor),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 99999,
                    }),
                    menu: (base, state) => ({
                      ...base,
                      zIndex: 99999,
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                    }),
                    control: (base, state) => ({
                      ...base,
    
                      backgroundColor: getThemeColor("action-details-background"),
                      border: getThemeColor("border"),
                      boxShadow: state.isFocused
                        ? "0 0 0 1px #0085ff"
                        : "none",
                      opacity: 1,
                      minHeight: "36px",
                      cursor: state.isDisabled ? "not-allowed" : "default",
                      "&:hover": {
                        borderColor: state.isFocused ? "#0085ff" : undefined,
                      },
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: getThemeColor("primary-color"),
                      opacity: 1,
                    }),
                    input: (base) => ({
                      ...base,
                      color: getThemeColor("primary-color"),
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: getThemeColor("primary-color"),
                    }),
                    option: (base, state) => ({
                      ...base,
                      color: getThemeColor("primary-color"),
                      backgroundColor: state.isFocused
                        ? getThemeColor("popup-hover")
                        : getThemeColor("action-details-background"),
                      "&:hover": {
                        backgroundColor: `${getThemeColor("popup-hover")} !important`,
                      },
                    }),
                  }}
                  isDisabled={!!templateToEdit}
                  placeholder="Select Agent..."
                />
              </div>
            ) : (
              <span
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontWeight: "500",
                }}
              >
                {info.getValue()}
              </span>
            )}

            {/* Added for personal template: hide row actions while that row is being edited. */}
            {!isEditingThisTemplate && (
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginRight: "15px",
                  flexShrink: 0,
                }}
              >
                <Icon
                  iconName="Edit"
                  style={{ fontSize: 17,   
                    cursor: isTemplateEditing ? "not-allowed" : "pointer",
                    opacity: isTemplateEditing ? 0.5 : 1, }}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (isTemplateEditing) return;
                    setTemplateSelectedRow(info.row.index);
                    setSelectedTemplate(template);
                    setTemplateToEdit(template);
                    setSelectedAgent({
                      value: template.agentId,
                      label: template.agentName,
                    });
                    setTemplateContent(template.templateContent || "");
                  
                    templateContentRef.current = template.templateContent || "";
                    setIsAddingTemplate(false);
                    setIsTemplateEditing(true);
                  }}
                />

                <Icon
                  iconName="Delete"
                  style={{ fontSize: 17,    cursor: isTemplateEditing ? "not-allowed" : "pointer",
                          opacity: isTemplateEditing ? 0.5 : 1, }}
                  onClick={(event) => {
                    event.stopPropagation();
                    if (isTemplateEditing) return;
                    openTemplateDeleteConfirm(template);
                  }}
                />
              </div>
            )}
          </div>
        );
      },
      show: true,
      headerClass: "list-view-header-cell",
      className: "list-view-cell",
      style: { width: "100%" },
      headerStyle: { width: "100%" },
    },
  ];
  const SelectedRowComponent = () => {
if (isStyleEditing) {
  return (
    <div
      style={{
        height: "100%",
        width: "100%",
        minWidth: 0,
        backgroundColor: mainBackgroundColor,
        display: "flex",
        flexDirection: "column",
        padding: "0px",
        overflow: "hidden",
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      <div
        style={{
          width: "100%",
          minWidth: 0,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "0px",
            marginTop: "0px",
            position: "absolute",
            top: "5px",
            left: "20px",
            right: "31px",
            bottom: "65px",
            display: "flex",
            minWidth: 0,
          }}
        >
          <textarea
            id="style-content"
            name="style-content"
            className="style-content-textarea"
            value={stylePromptContent}
            onChange={(e) => setStylePromptContent(e.target.value)}
            placeholder={t("addStyle.placeholder")}
            style={{
              width: "100%",
              height: "100%",
              flex: "1 1 auto",
              minWidth: 0,
              padding: "15px",
              border: getThemeColor("border"),
              borderRadius: "10px",
              fontFamily: "Segoe UI",
              fontSize: "14px",
              resize: "none",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "flex-start",
            position: "absolute",
            left: "20px",
            bottom: "18px",
            padding: "0px",
            flexShrink: 0,
          }}
        >
          <DefaultButton
            text={t("button.cancel")}
            onClick={closeStyleEditor}
            styles={{
              root: {
                border: getThemeColor("border"),
                borderRadius: "7px",
              },
            }}
          />

          <PrimaryButton
            text={t("button.save")}
            onClick={saveStyle}
            styles={{ root: { borderRadius: "7px" } }}
          />
        </div>
      </div>
    </div>
  );
}
    if (!selectedStyle) return null;

    return (
      <div style={{
        height: "100%",
        backgroundColor: mainBackgroundColor,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
      }}>
        <div style={{
          width: "94%",
          height: "100%",
          margin: "5px 20px",
          backgroundColor: "#ffffff",
          border: getThemeColor("border"),
          borderRadius: "10px",
          padding: "10px",
          overflow: "auto"
        }}>
          <div style={{
            fontFamily: "Arial, sans-serif",
            fontSize: "14px",
            color: "#000000",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word"
          }}>
            {selectedStyle.styles}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {authenticated && (
        <div
          className="main-container-body"
          style={{ background: mainBackgroundColor }}
        >
          {showDeleteConfirmModal && (
            <ConfirmModal
              handleConfirm={deleteStyle}
              handleNotConfirm={() => setShowDeleteConfirmModal(false)}
              showConfirmModal={showDeleteConfirmModal}
              message={t("myStyles.deletePreference")}
              title={t("myStyles.confirmDelete")}
              confirmButtonText={t("myStyles.delete")}
            />
          )}
          {/* Added for personal template: separate delete confirmation from styles. */}
          {showTemplateDeleteConfirmModal && (
            <ConfirmModal
              handleConfirm={deleteTemplate}
              handleNotConfirm={() => {
                setShowTemplateDeleteConfirmModal(false);
                setTemplateToDelete(null);
              }}
              showConfirmModal={showTemplateDeleteConfirmModal}
              message={t("myStyles.deleteMessage")}
              title="Confirm Delete"
              confirmButtonText="Delete"
            />
          )}
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              padding: "0px 3px",
              boxSizing: "border-box",
              marginTop: "10px",
              height: "calc(100% - 101px)",
            }}
          >
            <MyStylesTabSection />
            <div
              style={{
                borderBottom: getThemeColor("border"),
                width: "100%",
                boxSizing: "border-box",
              }}
            ></div>
            <SortPopupFilterSectionV4
              key={activeTab}
              handleApplyClick={handleApplyClick}
              placeholder={
                activeTab === "styles"
                  ? t("myStyles.searchPreferences")
                  : t("myStyles.searchTemplates")
              }
              buttonsTopBar={buttonsTopBar}
            />
            <style>
              {`
                .list-view-tr {
                  width: 100% !important;
                }
                .list-view-thead-tr {
                  width: 100% !important;
                }
                .list-view-tbody {
                  width: 100% !important;
                }
                .list-view-table {
                  width: 100% !important;
                }
                .personal-template-editor .fr-toolbar {
                  background: #ffffff !important;
                  color: #333333 !important;
                  z-index: 2 !important;
                }

                .personal-template-editor .fr-command,
                .personal-template-editor .fr-command svg {
                  color: #333333 !important;
                  fill: #333333 !important;
                }
                .personal-template-editor .fr-wrapper,
                .personal-template-editor .fr-element {
                  background: #ffffff !important;
                  color: #000000 !important;
                }

                /* Added for personal template: stretch Froala across the complete available editor area. */
                .personal-template-editor .fr-box {
                  width: 100% !important;
                  height: 100% !important;
                  margin: 0 !important;
                  display: flex !important;
                  flex: 1 1 auto !important;
                  flex-direction: column !important;
                  min-height: 0 !important;
                }
                .personal-template-editor .fr-wrapper {
                  display: flex !important;
                  flex: 1 1 auto !important;
                  min-height: 0 !important;
                    overflow-y: auto !important;
                   overflow-x: hidden !important;
                }

                
                .personal-template-editor .fr-element {
                  width: 100% !important;
                  min-height: 100% !important;
                  box-sizing: border-box !important;
                    overflow-wrap: anywhere !important;
                    word-break: break-word !important;
                  white-space: normal !important;
                }
               .style-content-textarea {
                   background-color: #ffffff !important;
                      color: #000000 !important;
                 }

                .style-content-textarea:focus {
                  outline: none !important;
                   box-shadow: none !important;
                     border-color: inherit !important;
                }

                .my-preferences-split-view {
                  height: 100%;
                  width: 100%;
                }

                .my-preferences-split-view .main-container-list-view-v3 {
                  display: grid !important;
                  grid-template-columns: 18% minmax(0, 1fr);
                  width: 100% !important;
                }

                .my-preferences-split-view .parent-list-view-v3 {
                  width: 100% !important;
                  min-width: 0;
                }

                .my-preferences-split-view .list-view-detail-section-v3 {
                  width: 100% !important;
                  min-width: 0;
                  overflow: hidden;
                }
 
                   
              `}
            </style>
            <QueryClientProvider client={queryClient}>
              {activeTab === "templates" && (
                <ListViewTableV3
                  columns={templateColumns}
                  pageIndex={templatePageIndex}
                  pageSize={templatePageSize}
                  setPagination={setTemplatePagination}
                  fetchData={fetchTemplatesData}
                  dataQueryState={templateDataQueryState}
                  setDataQueryState={setTemplateDataQueryState}
                  showPagination={true}
                  tabHeaderPresent={true}
                  listViewLoading={templateListViewLoading}
                  setListViewLoading={setTemplateListViewLoading}
                  listViewRef={templateListViewRef}
                  sortObj={sortObj}
                  filterObj={templateFilterObj}
                  uniqueKey={`personal-templates-${templateRefreshKey}`}
                  selectedRow={templateSelectedRow}
                  handleUserClick={(cell) => {
                    if (!isTemplateEditing) {
                      setTemplateSelectedRow(cell.row.index);
                      setSelectedTemplate(cell.row.original);
                    }
                  }}
                  selectedRowComponent={<SelectedTemplateComponent />}
                  showSideBySide={true}
                />
              )}

              {/* Existing My Styles rendering is retained; uniqueKey only isolates its cache. */}
              {activeTab === "styles" && (
                <div className="my-preferences-split-view">
                  <ListViewTableV3
                    columns={columns}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    setPagination={setPagination}
                    fetchData={fetchStylesData}
                    uniqueKey={`my-styles-${styleRefreshKey}`}
                    dataQueryState={dataQueryState}
                    setDataQueryState={setDataQueryState}
                    sortObj={sortObj}
                    filterObj={filterObj}
                    showPagination={true}
                    tabHeaderPresent={true}
                    listViewLoading={listViewLoading}
                    setListViewLoading={setListViewLoading}
                    listViewRef={listViewRef}
                    handleUserClick={(cell) => {
                      if (!isStyleEditing) {
                        handleUserClick(cell);
                      }
                    }}
                    selectedRow={selectedRow}
                    showSideBySide={true}
                    selectedRowComponent={SelectedRowComponent()}
                  />
                </div>
              )}
            </QueryClientProvider>
          </div>
        </div>
      )}
    </>
  );
};

export default MyStyles;
